import { render, staticRenderFns } from "./TrainingForm.vue?vue&type=template&id=61ae3bc4&"
import script from "./TrainingForm.vue?vue&type=script&lang=js&"
export * from "./TrainingForm.vue?vue&type=script&lang=js&"
import style0 from "./TrainingForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports